import { useContext } from 'react'
import {
  branch,
  compose,
  lifecycle,
  renderNothing,
  setPropTypes,
  withContext,
  withProps,
} from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { injectIntl } from 'react-intl'
import { selectRouteKey } from '../../../store/selectors/routes'
import { selectCurrentCELs } from '../../../store/selectors/home/loans'
import { prepareStateKey, fetchAirDna } from '../../../actions/airDna'
import { AIR_DNA } from '../../../constants'
import { selectPropertyDetailsMapWithHome } from '../../../store/selectors/airDna'
import { selectCorporateProfile } from '../../../store/selectors/customerProfile'
import { selectHasHomeData } from '../../../store/selectors/home'
import LoadingPanel from '../Loading/LoadingPanel'
import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useAmplitudeDebounceSetters } from '../../../hooks/tracking'

const propTypes = {
  locked: PropTypes.bool,
  stateKey: PropTypes.string.isRequired,
}

const contextTypes = propTypes // will pass prop as context

const AirDnaContainer = compose(
  setPropTypes(propTypes),
  withContext(contextTypes, ({ stateKey, locked }) => ({ stateKey, locked })),
  withProps(() => ({ routeKey: selectRouteKey() })),
  withProps(() => {
    const { ampli } = useContext(AmplitudeContext)
    const [trackModuleViewed] = useAmplitudeDebounceSetters(() =>
      ampli?.moduleViewed({
        module_name: AmplitudeEventConstants.AIRBNB,
      })
    )
    return { trackModuleViewed }
  }),
  connect(
    (state, { routeKey, stateKey }) => {
      const stateBranch = get(state.airDna, stateKey, {})
      const loans = selectCurrentCELs(state)

      const showExtraPayments = [
        routeKey === 'home',
        selectHasHomeData(state),
        loans.length,
      ].every(Boolean)

      return {
        showExtraPayments,
        loading: stateBranch.loading,
        params: stateBranch.params,
        error: stateBranch.error,
        corporateProfile: selectCorporateProfile(state),
        ...selectPropertyDetailsMapWithHome(state)[stateKey],
      }
    },
    (dispatch, { stateKey }) => ({
      fetch: params => dispatch(fetchAirDna(stateKey, params)),
      onSubmitExample: () =>
        dispatch(
          fetchAirDna(stateKey, {
            address: AIR_DNA.DEFAULT_ADDRESS.streetAddress,
            zipcode: AIR_DNA.DEFAULT_ADDRESS.zipcode,
          })
        ),
      prepare: () => dispatch(prepareStateKey(stateKey)),
    })
  ),
  lifecycle({
    componentDidMount() {
      const { prepare } = this.props
      prepare()
    },
  }),
  branch(
    props =>
      !get(
        props,
        'corporateProfile.showNightlyRentals',
        props.showNightlyRentals
      ),
    renderNothing
  ),
  branch(
    ({ loading }) => loading,
    () => LoadingPanel
  ),
  injectIntl
)

export default AirDnaContainer
